import { FIELD_NAMES } from '../../constants';
import DatePicker from './components/date-picker';
import DestinationSuggestions from './components/destination-suggestions';
import TravellerDetails from './components/traveller-details';

const fieldData = [
  {
    icon: 'search',
    modalComponent: DestinationSuggestions,
    name: FIELD_NAMES.WHERE,
    placeholder: 'Search destinations',
  },
  {
    icon: 'calendar',
    modalComponent: DatePicker,
    name: FIELD_NAMES.WHEN,
  },
  {
    hasButton: true,
    icon: 'user',
    modalComponent: TravellerDetails,
    name: FIELD_NAMES.WHO,
  },
];

export default fieldData;
